import { Link } from 'react-router-dom';
import { getFeaturedArticles } from '@/mocks/articles';

export default function HeroSection() {
  const featured = getFeaturedArticles();
  const mainArticle = featured[0];
  const sideArticles = featured.slice(1, 3);

  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={mainArticle.image}
          alt={mainArticle.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/70"></div>
      </div>

      <div className="relative z-10 h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-end pb-12 md:pb-16">
        <div className="w-full">
          <Link to={`/category/${mainArticle.categorySlug}`} className="inline-block w-fit mb-3">
            <span className="text-xs font-medium bg-primary-500 text-white px-3 py-1 rounded-full">{mainArticle.categoryName}</span>
          </Link>
          <Link to={`/article/${mainArticle.slug}`} className="block cursor-pointer">
            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight max-w-3xl hover:text-primary-100 transition-colors">
              {mainArticle.title}
            </h1>
          </Link>
          <p className="text-sm md:text-base text-white/70 mt-3 max-w-2xl line-clamp-2 leading-relaxed">
            {mainArticle.excerpt}
          </p>
          <div className="flex items-center gap-4 mt-4 text-xs md:text-sm text-white/60">
            <span className="flex items-center gap-1"><i className="ri-calendar-line"></i> {mainArticle.publishDate}</span>
            <span className="flex items-center gap-1"><i className="ri-eye-line"></i> {mainArticle.views.toLocaleString()} 阅读</span>
            <span className="flex items-center gap-1"><i className="ri-user-line"></i> {mainArticle.author}</span>
          </div>
        </div>

        <div className="hidden lg:flex gap-3 mt-6 w-full max-w-4xl">
          {sideArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="flex-1 flex items-center gap-3 p-3 rounded-lg bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all cursor-pointer group border border-white/10"
            >
              <div className="w-16 h-16 flex-shrink-0 rounded-md overflow-hidden bg-background-300">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm font-medium text-white line-clamp-2 group-hover:text-primary-100 transition-colors leading-snug">{article.title}</h3>
                <span className="text-xs text-white/50 mt-1 block">{article.publishDate}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}